import { RootState } from "../..";

export const selectCurrent = (state: RootState) => state.products.data.current;

export const selectIsCurrentLoading = (state: RootState) =>
  state.products.loading.current;

export const selectIsPurchaseLoading = (state: RootState) =>
  state.products.loading.purchase;
